import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	FnCheckboxEventFilter,
	FnCheckboxFilterOption,
} from '../../../../event-filter/fn-event-filter.model';
import { FnGridColumn } from './../../../model/fn-grid-column';
@Component({
	selector: 'fn-grid-column-search-filter',
	templateUrl: './fn-grid-column-search-filter.component.html',
	styleUrls: ['./fn-grid-column-search-filter.component.scss'],
})
export class FnGridColumnSearchFilterComponent implements OnInit {
	constructor() {}
	placeholder = ' search...';
	searchTerm: string;
	selectedValue: string;
	@Input() column: FnGridColumn;
	@Output() callback = new EventEmitter<any>();
	numTypeArray = ['CURRENCY', 'NUMBER', 'PHONE_NUMBER'];
	isParentSelected = true;
	eventFilter: FnCheckboxEventFilter;
	//private boolean = num
	numFrom: string;
	numTo: string;
	componentType: string;
	searchOnRowsByCol() {
		let noDataSelected = false;
		if (this.componentType === 'BOOLEAN') {
			if (this.eventFilter.parentOption.isSelected) {
				this.searchTerm = '';
			} else if (this.eventFilter.noOfOptionSelected === 0) {
				noDataSelected = true;
			} else {
				this.searchTerm = this.eventFilter.selectedOptionArray[0];
			}
		}
		this.callback.emit({
			type: this.componentType,
			searchTerm: this.searchTerm,
			numFrom: this.numFrom || '',
			numTo: this.numTo || '',
			noDataSelected,
		});
	}
	getType() {
		return this.numTypeArray.includes(this.column.componentTypeID)
			? 'NUM'
			: this.column.componentTypeID;
	}
	ngOnInit() {
		this.componentType = this.getType();
		this.placeholder = this.column.headerName + this.placeholder;
		if (this.componentType === 'BOOLEAN') {
			this.setBoolFilterData();
		}
	}

	reset() {
		this.searchTerm = '';
		this.numTo = '';
		this.numFrom = '';
		if (this.componentType === 'BOOLEAN') {
			this.eventFilter.reselectAllOptions();
		}
		this.callback.emit('');
	}
	private setBoolFilterData() {
		this.eventFilter = new FnCheckboxEventFilter(
			'hd',
			'BOOLEAN',
			new FnCheckboxFilterOption('(Select All)', 'ALL')
		);
		this.eventFilter.buildFnFilterArray(
			[
				{
					displayName: 'true',
					primaryKey: 'TRUE',
				},
				{
					displayName: 'false',
					primaryKey: 'FALSE',
				},
			],
			'displayName',
			'primaryKey'
		);
	}
}
